import { render, staticRenderFns } from "./SkillSigns.vue?vue&type=template&id=84f3b4e8"
import script from "./SkillSigns.vue?vue&type=script&lang=ts"
export * from "./SkillSigns.vue?vue&type=script&lang=ts"
import style0 from "./SkillSigns.vue?vue&type=style&index=0&id=84f3b4e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports